export const prettyBoolean = (condition: boolean | null): string => {
  if (condition === null) return '-';

  return condition ? 'Yes' : 'No';
};
